<div class="container">
  <div class="row">
    <div class="col-sm-1"></div>
    <div class="col-sm-10">
      <h3 class="text-center title-system-configuration">
        {{ 'label.SystemConfiguration' | translate }}
      </h3>
      <span class="fa fa-filter"></span>
      <input
        [(ngModel)]="filter"
        class="form-control custom-input"
        (keyup)="onFilterChanged()"
      />
      <table class="system-settings">
        <tbody>
          <tr class="item-row" *ngFor="let item of filteredSettings">
            <td>
              <div class="item-name">
                <span
                  [class]="
                    'fa ' +
                    (item.level == 'Application' ? 'fa-bars' : 'fa-user')
                  "
                ></span>
                {{ item.name }}
              </div>
              <div class="item-description">
                {{ item.description }}
              </div>
            </td>
            <td>
              <div class="item-value">
                {{ item.value }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-sm-1"></div>
  </div>
</div>
